module.exports = __webpack_public_path__ + "assets/img/logo3_600_600.6640fb8a.png";